import Marquee from "react-fast-marquee";

const BRANDS = [
  "Stüdio Moss",
  "Orbital Skin",
  "Hellhound Coffee",
  "Lumen Wear",
  "Northbound",
  "Wildclaim",
  "Atlas & Vine",
  "Paper Orchid",
  "Hexa Goods",
  "Saltwater Co.",
];

export default function LogoCloud() {
  return (
    <section
      data-testid="logo-cloud"
      className="py-16 border-y border-white/5 bg-[#0B0B0D]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
        <p className="text-[11px] tracking-[0.3em] uppercase text-[#A1A1AA] text-center">
          Quietly powering influencer discovery at
        </p>
      </div>
      <Marquee gradient gradientColor="#0B0B0D" gradientWidth={80} speed={40} pauseOnHover>
        {BRANDS.map((b) => (
          <div
            key={b}
            className="mx-10 font-display text-2xl md:text-3xl uppercase tracking-tight text-white/35 hover:text-white transition-colors whitespace-nowrap"
          >
            {b}
          </div>
        ))}
      </Marquee>
    </section>
  );
}
